import BaseValidator from 'services/validations/base-validator';
import {RuleItemInterface, BoostStatementInterface} from '../interfaces';

export default class BoostStatementsValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {ruleItem, ruleName} = this.dependencies;

        const boostStatements = ruleItem.getBoostStatements();

        if (!boostStatements.length) {
            this.addError(`There has to be at least on statement in ${ruleName}.`);
        }

        boostStatements.map((boostStatement) => this.validateBoostStatement(ruleItem, boostStatement));
    }

    private validateBoostStatement(ruleItem: RuleItemInterface, boostStatement: BoostStatementInterface): void {
        // @ts-ignore
        const {ruleName} = this.dependencies;

        if (ruleItem.isStatementTypePosition() && boostStatement.isBoostForPlayer()) {
            this.addError(
                `Player statement is forbidden if the Position option is selected as key setting in ${ruleName}.`,
            );
        } else if (boostStatement.isBoostForPlayer() && !boostStatement.getBoostedPlayer()) {
            this.addError(`Player has to be chosen for statement in ${ruleName}.`);
        } else if (boostStatement.isBoostForPosition() && !boostStatement.getBoostedPositions().length) {
            this.addError(`At least one position has to be chosen in ${ruleName}.`);
        }
    }
}
